(function () {
    'use strict';

    angular
        .module('wsl.core')
        .directive('wslIsEqual', isEqual);

    isEqual.$inject = [];

    /* @ngInject */
    function isEqual() {

        var directive = {
            link: link,
            restrict: 'A',
            require: 'ngModel'
        };
        return directive;

        function link(scope, element, attrs, ctrl) {
            var compareValue = attrs.wslIsEqual;
            ctrl.$parsers.unshift(function (value) {
                ctrl.$setValidity('wsl-isEqual', value === compareValue);
                return value;
            });

            // Watch if whole model has changed
            scope.$watch(attrs.wslIsEqual, function(newVal) {
                if(angular.isDefined(newVal)) {
                    compareValue = newVal;
                   //var modelValue = ctrl.$modelValue;
                    ctrl.$setValidity('wsl-isEqual', element.val() === newVal);
                }

            }, true);
        }
    }
})();
